import React, { useState, useEffect, useRef } from 'react'
import styles from "../styles/home.module.css"
import chapter from "../images/chapter.jpg"
import tabling from "../images/tabling.jpg"
import pier from "../images/pier.jpg"
import omicrons from "../images/omicrons.jpg"
import upsilons from "../images/upsilons.jpg"
import retreat from "../images/W23Retreat.jpg"
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { RiServiceLine } from "react-icons/ri";
import { GrGroup } from "react-icons/gr";
import { LuGraduationCap } from "react-icons/lu";

const Home = () => {
	const [currentSlide, setCurrentSlide] = useState(0)
	const totalSlides = 6
	const sliderRef = useRef(null)
	const touchStartX = useRef(null)

	const images = [
		{ src: chapter, alt: "Chapter" },
		{ src: tabling, alt: "Tabling" },
		{ src: pier, alt: "Pier" },
		{ src: omicrons, alt: "Omicrons" },
		{ src: upsilons, alt: "Upsilons" },
		{ src: retreat, alt: "Winter 2023 Retreat" }
	]

	useEffect(() => {
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						const img = entry.target;
						img.src = img.dataset.src;
						observer.unobserve(img);
					}
				});
			},
			{
				rootMargin: '50px 0px',
				threshold: 0.1
			}
		);

		const images = sliderRef.current?.querySelectorAll('img[data-src]');
		images?.forEach(img => observer.observe(img));

		return () => {
			images?.forEach(img => observer.unobserve(img));
		};
	}, []);

	const nextSlide = () => {
		setCurrentSlide(current => (current + 1) % totalSlides)
	}

	const prevSlide = () => {
		setCurrentSlide(current => (current - 1 + totalSlides) % totalSlides)
	}

	const goToSlide = (index) => {
		setCurrentSlide(index)
	}

	const handleTouchStart = (e) => {
		touchStartX.current = e.touches[0].clientX
	}

	const handleTouchEnd = (e) => {
		if (touchStartX.current === null) return
		const delta = touchStartX.current - e.changedTouches[0].clientX
		if (Math.abs(delta) > 50) delta > 0 ? nextSlide() : prevSlide()
		touchStartX.current = null
	}

	useEffect(() => {
		const timer = setInterval(nextSlide, 7000)
		return () => clearInterval(timer)
	}, [currentSlide])

	return (
		<div className={styles.home}>
			<div className={styles.banner} onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
				<div className={styles.slider} ref={sliderRef}>
					{images.map((image, index) => (
						<img 
							key={index}
							className={`${styles.chapter} ${currentSlide === index ? styles.active : ''}`}
							data-src={image.src}
							src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
							alt={image.alt}
						/>
					))}
				</div>
				<div className={styles.overlay}>
					<div className={`${styles.arrowContainer} ${styles.left}`} onClick={prevSlide}>
						<IoIosArrowBack className={styles.arrow}/>
					</div>
					<div className={`${styles.title} hero-fade`}>
						<h1>UCR Theta Tau</h1>
						<span className={styles.heroAccent}></span>
						<h2>Sigma Delta Chapter</h2>
						<p>The Only Co-Ed Professional Engineering Fraternity at UCR</p>
					</div>
					<div className={`${styles.arrowContainer} ${styles.right}`} onClick={nextSlide}>
						<IoIosArrowForward className={styles.arrow}/>
					</div>
					<div className={styles.dots}>
						{[...Array(totalSlides)].map((_, index) => (
							<div key={index} className={`${styles.dot} ${index === currentSlide ? styles.activeDot : ''}`} onClick={() => goToSlide(index)} />
						))}
					</div>
				</div>
			</div>
			<div className={styles.body}>
				<div className={`${styles.pillarsHead} reveal`}>
					<span className={styles.eyebrow}>What we stand for</span>
					<h1 className={styles.heading}>Our Three Pillars</h1>
					<div className={styles.rule}></div>
				</div>
				<div className={styles.pillarsContainer}>
					<div className={`${styles.pillar} ${styles.group} reveal d1`}>
						<div className={styles.icon}><GrGroup /></div>
						<h2>Brotherhood</h2>
						<div className={styles.underline}></div>
						<p>We strive to develop bonds between brothers that will last a lifetime.</p>
					</div>
					<div className={`${styles.pillar} ${styles.cap} reveal d2`}>
						<div className={styles.icon}><LuGraduationCap /></div>
						<h2>Profession</h2>
						<div className={styles.underline}></div>
						<p>We aim to prepare for life in college, our careers, and beyond.</p>
					</div>
					<div className={`${styles.pillar} ${styles.heart} reveal d3`}>
						<div className={styles.icon}><RiServiceLine /></div>
						<h2>Service</h2>
						<div className={styles.underline}></div>
						<p>We are involved in projects and events that give back to the community.</p>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Home